export default class RowDetailsModal {
	/* @ngInject */
	/**
	 *
	 * @param {Required<RowDetailsModalType.Resolve['kid']>} kid
	 * @param {Required<RowDetailsModalType.Resolve['readonly']>} readonly
	 * @param {Required<RowDetailsModalType.Resolve['locked']>} locked
	 * @param {angular.ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		kid,
		readonly,
		locked,

		$uibModalInstance,
	) {
		this.kid = kid;

		const isReadonly = readonly;

		const isLocked = locked;

		this.options = {
			readOnly: isReadonly,
			locked:   isLocked,
			modal:    $uibModalInstance,
			viewMode: 1,
		};
		this.formName = 'test';
		this.create = false;

		this.$uibModalInstance = $uibModalInstance;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
